/**
 * Powerlete recent searches — stores the last few search terms in localStorage and
 * renders them in the predictive-search empty state. Defined once; the
 * <powerlete-recent-searches> element upgrades wherever it appears (incl. AJAX-injected).
 */
(() => {
  const KEY = 'pw-recent-searches';
  const MAX = 5;

  const read = () => {
    try {
      const v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  };
  const write = (arr) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX)));
    } catch (e) {
      /* storage unavailable — recent searches just won't persist */
    }
  };
  const add = (term) => {
    term = (term || '').trim();
    if (!term || term.length > 80) return;
    const next = read().filter((t) => t.toLowerCase() !== term.toLowerCase());
    next.unshift(term);
    write(next);
    document.querySelectorAll('powerlete-recent-searches').forEach((el) => el.render && el.render());
  };
  const escape = (s) =>
    s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  // Capture search submissions to record the term.
  if (!window.__pwRecentSearchBound) {
    window.__pwRecentSearchBound = true;
    document.addEventListener(
      'submit',
      (e) => {
        const form = e.target;
        if (!form || form.tagName !== 'FORM') return;
        if (!(form.getAttribute('action') || '').includes('/search')) return;
        const input = form.querySelector('input[name="q"], input[name="search"], input[type="search"]');
        if (input) add(input.value);
      },
      true
    );
  }

  if (!customElements.get('powerlete-recent-searches')) {
    customElements.define(
      'powerlete-recent-searches',
      class extends HTMLElement {
        connectedCallback() {
          this.list = this.querySelector('[data-pw-recent-list]');
          const clearBtn = this.querySelector('[data-pw-recent-clear]');
          if (clearBtn && !clearBtn.dataset.bound) {
            clearBtn.dataset.bound = 'true';
            clearBtn.addEventListener('click', () => {
              write([]);
              this.render();
            });
          }
          this.render();
        }

        render() {
          const items = read();
          if (!this.list) return;
          if (!items.length) {
            this.hidden = true;
            return;
          }
          this.hidden = false;
          // Build from the active locale's search route so chip clicks keep market/locale context
          // (e.g. /en-gb/search); fall back to the root path when Theme.routes is unavailable.
          const searchUrl = window.Theme?.routes?.search_url || '/search';
          this.list.innerHTML = items
            .map(
              (t) =>
                '<li><a class="pills__pill" href="' + searchUrl + '?q=' +
                encodeURIComponent(t) +
                '&options%5Bprefix%5D=last">' +
                escape(t) +
                '</a></li>'
            )
            .join('');
        }
      }
    );
  }
})();
